import React from 'react';
import _ from 'lodash';

import {Accordion, Button} from '../index';
import Config from '../../utils/Configuration';
import Utility from '../../utils/Helper';
import Price from '../Label/Price';

const PlanCard = ({plan = {}, buttonLabel, action, title, descriptionMinHeight = 0, cardMinHeight = 0}) => {
    const showPlanCard = () => {
        const {planDetails = {}, planInfo = {}, planShortName} = plan;
        const {descriptionList = [], benefits = [], recommended = {}, mainPackage = {}, packageInclude = {}} = planInfo;
        const [speed, unit] = (planShortName || '').split(' ');

        const generateDescriptionTitle = (icon, tagName, title) => {
            return (
                <div className='d-flex'>
                    <div>
                        <img
                            className='description-icon'
                            src={`${Config.apiConfig.aemEndPoint}${icon}`}
                            alt='description_icon'
                        />
                    </div>
                    <div
                        className={`ms-2 d-flex flex-column ${
                            tagName ? 'justify-content-between' : 'justify-content-center'
                        }`}
                    >
                        {tagName && (
                            <div>
                                <span className='blue-tag fs-12 maxis-semiBold text-white ls-100 bg-lightish-blue'>
                                    {tagName}
                                </span>
                            </div>
                        )}
                        <div className='fs-14 text-black maxis lh-normal mb-0 mt-1'>{title}</div>
                    </div>
                </div>
            );
        };

        const generateBenefitTitle = (tagName, title) => {
            return (
                <div className='lh-17px'>
                    {tagName && (
                        <span className='blue-tag fs-12 maxis-semiBold text-white ls-100 bg-lightish-blue me-2'>
                            {tagName}
                        </span>
                    )}
                    <span className='fs-14 text-black maxis-bold'>{title}</span>
                </div>
            );
        };

        const generateRecommendedTitle = (title) => {
            return <div className='fs-14 text-brown-grey maxis'>{title}</div>;
        };

        const generateMainPackageTitle = (title) => {
            return <div className='fs-16 text-frog-green maxis' dangerouslySetInnerHTML={{__html: title}} />;
        };

        const generatePackageTitle = (title) => {
            return <div className='fs-14 text-black maxis-bold'>{title}</div>;
        };

        return (
            <div className='plan-card'>
                <div className='card plane m-0 position-relative' style={{minHeight: cardMinHeight}}>
                    {planDetails.tagName && (
                        <div className='position-absolute left-0 top-0 w-100 d-flex justify-content-center'>
                            <div className='header-tag'>{planDetails.tagName}</div>
                        </div>
                    )}
                    <div className='body-card cursor-pointer'>
                        <h2 className='plan-name text-dark-blue-3 mb-17px maxis-bold'>
                            <span className='mb-2px fs-16 lh-18px'>{title}</span>
                            <span className='d-block'>
                                <span className='fs-35 lh-120 me-1'>{speed}</span>
                                <span className='fs-24 lh-117'>{unit}</span>
                            </span>
                        </h2>

                        <div className='description-list' style={{minHeight: descriptionMinHeight}}>
                            {(descriptionList || []).map((item, index) => {
                                return (
                                    <div
                                        key={`description_list_${index}`}
                                        className={`description-item position-relative ${index > 0 ? 'mt-15px' : ''} ${
                                            item.tagName ? 'show-tag' : ''
                                        }`}
                                    >
                                        <Accordion
                                            title={generateDescriptionTitle(item.icon, item.tagName, item.title)}
                                            isAccordionArrow
                                        >
                                            {(item.subDescriptionList || []).length > 0 && (
                                                <ul className='pt-10px pl-20px mb-0'>
                                                    {item.subDescriptionList.map((text, subIndex) => {
                                                        return (
                                                            <li
                                                                key={`sub_description_${subIndex}`}
                                                                className='fs-14 text-gunmetal lh-18px'
                                                                dangerouslySetInnerHTML={{
                                                                    __html: text
                                                                }}
                                                            />
                                                        );
                                                    })}
                                                </ul>
                                            )}
                                        </Accordion>
                                    </div>
                                );
                            })}
                        </div>

                        <div className='mt-25px mb-15px maxis-bold text-dark-blue-3 text-center'>
                            <Price
                                className='fs-24'
                                numberClass='fs-35'
                                mthClass='fs-18 fs-md-24'
                                price={plan.planPrice || '--'}
                                mth
                            />
                            {Utility.getValues(plan, 'pricing.rrpPrice') && (
                                <div className='maxis text-brown-grey text-center strike-through'>
                                    <Price className='fs-16' price={Utility.getValues(plan, 'pricing.rrpPrice')} mth />
                                </div>
                            )}
                        </div>

                        <div className='plan-action mb-15px'>
                            <Button
                                onClick={() => action(plan)}
                                buttonClass='primary text-uppercase mb-0 ls-150 button-hover-anim '
                                buttonLabel={buttonLabel}
                            />
                        </div>

                        <div className='plan-benefits'>
                            {(benefits || []).map((benefitItem, benefitIndex) => {
                                return (
                                    <div key={`benefits_item_${benefitIndex}`} className='mb-2px'>
                                        <Accordion
                                            title={generateBenefitTitle(benefitItem.tagName, benefitItem.title)}
                                            isAccordionArrow
                                        >
                                            {benefitItem.description && (
                                                <span className='fs-14 text-gunmetal lh-18px mt-1px'>
                                                    {benefitItem.description}
                                                </span>
                                            )}
                                        </Accordion>
                                    </div>
                                );
                            })}
                        </div>

                        {!_.isEmpty(recommended) && (
                            <div className='mt-15px'>
                                <Accordion title={generateRecommendedTitle(recommended.title)} isAccordionArrow>
                                    {(recommended.recommendedList || []).length > 0 && (
                                        <ul className='pt-1 pl-20px mb-0'>
                                            {recommended.recommendedList.map((recText, recIndex) => {
                                                return (
                                                    <li
                                                        key={`recommended_item_${recIndex}`}
                                                        className='fs-14 text-brown-grey lh-18px'
                                                    >
                                                        {recText}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </Accordion>
                                {(!_.isEmpty(mainPackage) || !_.isEmpty(packageInclude)) && <hr></hr>}
                            </div>
                        )}

                        {!_.isEmpty(mainPackage) && (
                            <div className='mt-15px'>
                                {generateMainPackageTitle(mainPackage.title)}
                                {(mainPackage.mainPackageList || []).length > 0 && (
                                    <ul className='pt-1 pl-20px mb-0'>
                                        {mainPackage.mainPackageList.map((mainPackText, mainPackIndex) => {
                                            return (
                                                <li
                                                    key={`main_package_item_${mainPackIndex}`}
                                                    className='fs-14 text-brown-grey lh-18px'
                                                >
                                                    {mainPackText}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                )}
                            </div>
                        )}

                        {!_.isEmpty(packageInclude) && (
                            <div className='mt-15px'>
                                <Accordion title={generatePackageTitle(packageInclude.title)} isAccordionArrow>
                                    {(packageInclude.packageIncludeList || []).length > 0 && (
                                        <ul className='pt-1 pl-20px mb-0'>
                                            {packageInclude.packageIncludeList.map((packText, packIndex) => {
                                                return (
                                                    <li
                                                        key={`package_item_${packIndex}`}
                                                        className='fs-14 text-gunmetal lh-18px'
                                                    >
                                                        {packText}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </Accordion>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    return showPlanCard();
};

export default PlanCard;
